import { render, staticRenderFns } from "./avaliar-estabelecimento.vue?vue&type=template&id=46a736ee&"
import script from "./avaliar-estabelecimento.vue?vue&type=script&lang=ts&"
export * from "./avaliar-estabelecimento.vue?vue&type=script&lang=ts&"
import style0 from "./avaliar-estabelecimento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a736ee')) {
      api.createRecord('46a736ee', component.options)
    } else {
      api.reload('46a736ee', component.options)
    }
    module.hot.accept("./avaliar-estabelecimento.vue?vue&type=template&id=46a736ee&", function () {
      api.rerender('46a736ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/avaliar-estabelecimento/avaliar-estabelecimento.vue"
export default component.exports